import { SearchFields,AdToApprove, SubToProcess, HistoryEntry, atolUser,userAssociation, ToningRequest, toningJob, NewLiveRunDate, trafficNote, CreativeChange, RunDateToDelete } from "./interfaces";
import axios from "axios";
import { Annotation, ImageAnnotation,ShapeType,Geometry } from "@annotorious/annotorious";
import { ATOLAnnotation, mailMessage } from "./interfaces";
import { useContext } from "react";
import { UserContext } from "../components/UserContext";
import { makeLongDateTime } from "../components/DateTimeHelpers";
import { longDateTime } from '../services/interfaces';
import { UploadFileInfo } from "@progress/kendo-react-upload"
import { redirect } from "react-router-dom";
import { elements } from "@progress/kendo-react-common";

export const fetchWeatherForecast = async () => {
    try {
        const response = await fetch('/api/weatherforecast');
        //console.log(response);
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        const data = await response.json();
        return data;
        //return "OK";
    } catch (error) {
        console.error('There was a problem with the fetch operation:', error);
        throw error;
    }
};

export async function getCustomerList(){
    const url = "/api/GetCustomerList";
    try{
      const response = await fetch(url,{
        headers:{
        },
        method:"GET"
       }
      );
      if (!response.ok) {
        throw new Error(`Response status: ${response.status}`);
      }else{            
        const data = await response.json();
        return data;
      }
    }
    catch(error){
        if (error instanceof Error) {
            console.error(error.message);
          } else {
            console.error('An unknown error occurred');
          }
      return "error";
    }
  }

  export async function getStatusList(){
    const url = "/api/GetStatusList";
    try{
      const response = await fetch(url,{
        headers:{
        },
        method:"GET"
       }
      );
      if (!response.ok) {
        if (response.status===401){
          window.location.replace("/Login")
        }
          //throw new Error(`Response status: ${response.status}`);
      }else{            
        const data = await response.json();
        return data;
      }
    }
    catch(error){
      if (error instanceof Error) {
        console.error(error.message);
      } else {
        console.error('An unknown error occurred');
      }
      redirect("/Login");
    }
  }

  export async function getSubStatusList(){
    const url = "/api/GetSubStatusList";
    try{
      const response = await fetch(url,{
        headers:{
        },
        method:"GET"
       }
      );
      if (!response.ok) {
        throw new Error(`Response status: ${response.status}`);
      }else{            
        const data = await response.json();
        return data;
      }
    }
    catch(error){
      if (error instanceof Error) {
        console.error(error.message);
      } else {
        console.error('An unknown error occurred');
      }
      redirect("/Login");
    }
  }

  export async function getSavedQueries(){
    const url = "/api/GetSavedQueries";
    try{
      const response = await fetch(url,{
        headers:{
        },
        method:"GET"
       }
      );
      if (!response.ok) {
        throw new Error(`Response status: ${response.status}`);
      }else{            
        const data = await response.json();
        return data;
      }
    }
    catch(error){
      if (error instanceof Error) {
        console.error(error.message);
      } else {
        console.error('An unknown error occurred');
      }
      redirect("/Login");
    }
  }

  export async function fillDashboard(statuses:string){ 
    const url = "/api/FillDashboard?statuses="+statuses;
    try{
      const response = await fetch(url,{
        headers:{
        },
        method:"GET"
       }
      );
      if (!response.ok) {
        throw new Error(`Response status: ${response.status}`);
      }else{            
        const data = await response.json();
        return data;
      }
    }
    catch(error){
        if (error instanceof Error) {
            console.error(error.message);
          } else {
            console.error('An unknown error occurred');
          }
      return [];
    }
  }

  export async function getAdRecord(slug:string){ 
    const url = "/api/GetAdRecord?slug="+slug;
    try{
      const response = await fetch(url,{
        headers:{
        },
        method:"GET"
       }
      );
      if (!response.ok) {
        throw new Error(`Response status: ${response.status}`);
      }else{            
        const data = await response.json();
        return data;
      }
    }
    catch(error){
        if (error instanceof Error) {
            console.error(error.message);
          } else {
            console.error('An unknown error occurred');
          }
      return [];
    }
  }


  export async function runQuery(fields:string){ 

    console.log(fields);
    
    const url = "/api/Search";
     try{
      const response = await fetch(url,{
         headers:{
          "Content-Type": "application/json"
         },
         method:"POST",
         body:fields
        }
       );
       if (!response.ok) {
         throw new Error(`Response status: ${response.status}`);
       }else{            
         const data = await response.json();
         return data;
       }
     }
     catch(error){
         if (error instanceof Error) {
             console.error(error.message);
           } else {
             console.error('An unknown error occurred');
           }
      return [];
     }
  }

  export async function getRepList(){
    const url = "/api/GetSalesmanList";
    try{
      const response = await fetch(url,{
        headers:{
        },
        method:"GET"
       }
      );
      if (!response.ok) {
        throw new Error(`Response status: ${response.status}`);
      }else{            
        const data = await response.json();
        return data;
      }
    }
    catch(error){
        if (error instanceof Error) {
            console.error(error.message);
          } else {
            console.error('An unknown error occurred');
          }
      return "error";
    }
  }

  export async function getSectionList(){
    const url = "/api/GetSectionList";
    try{
      const response = await fetch(url,{
        headers:{
        },
        method:"GET"
       }
      );
      if (!response.ok) {
        throw new Error(`Response status: ${response.status}`);
      }else{            
        const data = await response.json();
        return data;
      }
    }
    catch(error){
        if (error instanceof Error) {
            console.error(error.message);
          } else {
            console.error('An unknown error occurred');
          }
      return "error";
    }
  }

  export async function getTeamList(){
    const url = "/api/GetTeamList";
    try{
      const response = await fetch(url,{
        headers:{
        },
        method:"GET"
       }
      );
      if (!response.ok) {
        throw new Error(`Response status: ${response.status}`);
      }else{            
        const data = await response.json();
        return data;
      }
    }
    catch(error){
        if (error instanceof Error) {
            console.error(error.message);
          } else {
            console.error('An unknown error occurred');
          }
      return "error";
    }
  }

  export async function getSizeList(ruGroup:string=""){
    
    const url = ruGroup !=""? "/api/GetSizeList": "api/GetSizeList/?ruGroup="+ruGroup;
    try{
      const response = await fetch(url,{
        headers:{
        },
        method:"GET"
       }
      );
      if (!response.ok) {
        throw new Error(`Response status: ${response.status}`);
      }else{            
        const data = await response.json();
        return data;
      }
    }
    catch(error){
        if (error instanceof Error) {
            console.error(error.message);
          } else {
            console.error('An unknown error occurred');
          }
      return "error";
    }
  }

  export async function getColTypeList(ruGroup:string=""){
    
    var url 
    if (ruGroup ===""){
      url= "/api/GetColTypeList";
    }else{
      url= "api/GetColTypeList/?ruGroup="+ruGroup;
    } 
    try{
      const response = await fetch(url,{
        headers:{
        },
        method:"GET"
       }
      );
      if (!response.ok) {
        throw new Error(`Response status: ${response.status}`);
      }else{            
        const data = await response.json();
        return data;
      }
    }
    catch(error){
        if (error instanceof Error) {
            console.error(error.message);
          } else {
            console.error('An unknown error occurred');
          }
      return "error";
    }
  }

  export async function getModSizeList(site:string="", colType:string=""){
    
    const url = "api/GetModSizeList/?site="+site+"&colType="+colType;
    try{
      const response = await fetch(url,{
        headers:{
        },
        method:"GET"
       }
      );
      if (!response.ok) {
        throw new Error(`Response status: ${response.status}`);
      }else{            
        const data = await response.json();
        return data;
      }
    }
    catch(error){
        if (error instanceof Error) {
            console.error(error.message);
          } else {
            console.error('An unknown error occurred');
          }
      return "error";
    }
  }


  export async function getSiteList(ruGroup:string=""){
    
    console.log(window.location);
    const url = ruGroup !=""? window.location.origin + "/api/GetSiteList": window.location.origin+"/api/GetSiteList/?ruGroup="+ruGroup;
    try{
      const response = await fetch(url,{
        headers:{
        },
        method:"GET"
       }
      );
      if (!response.ok) {
        throw new Error(`Response status: ${response.status}`);
      }else{            
        const data = await response.json();
        return data;
      }
    }
    catch(error){
        if (error instanceof Error) {
            console.error(error.message);
          } else {
            console.error('An unknown error occurred');
          }
      return "error";
    }
  }

  export async function getPubList(ruGroup:string=""){
    
    const url = ruGroup==""? "/api/GetPubList": "api/GetPubList/?ruGroup="+ruGroup;
    try{
      const response = await fetch(url,{
        headers:{
        },
        method:"GET"
       }
      );
      if (!response.ok) {
        throw new Error(`Response status: ${response.status}`);
      }else{            
        const data = await response.json();
        return data;
      }
    }
    catch(error){
        if (error instanceof Error) {
            console.error(error.message);
          } else {
            console.error('An unknown error occurred');
          }
      return "error";
    }
  }

  export async function updateAdStatus(element:string="", status:string=""){
    
    const url = "/api/UpdateAdStatus/?element="+element + "&status=" + status;
    try{
      const response = await fetch(url,{
        headers:{
        },
        method:"GET"
       }
      );
      if (!response.ok) {
        throw new Error(`Response status: ${response.status}`);
      }else{            
        const data = await response.json();
        return data;
      }
    }
    catch(error){
        if (error instanceof Error) {
            console.error(error.message);
          } else {
            console.error('An unknown error occurred');
          }
      return "error";
    }
  }

export async function setStat2Field(element:string="", field:string="", value:string=""){
    
    const url = "/api/SetStat2Field/?element="+element + "&field=" + field + "&value=" + encodeURIComponent(value);
    try{
      const response = await fetch(url,{
        headers:{
        },
        method:"GET"
       }
      );
      console.log(response);
      if (!response.ok) {
        throw new Error(`Response status: ${response.status}`);
      }else{            
        const data = await response.json();
        return data;
      }
    }
    catch(error){
        if (error instanceof Error) {
            console.error(error.message);
          } else {
            console.error('An unknown error occurred');
          }
      return "error";
    }
  }

 
  export async function getAdContacts(element:string=""){
    
    const url = "/api/GetAdContacts?element=" + element;
    try{
      const response = await fetch(url,{
        headers:{
        },
        method:"GET"
       }
      );
      if (!response.ok) {
        throw new Error(`Response status: ${response.status}`);
      }else{            
        const data = await response.json();
        return data;
      }
    }
    catch(error){
        if (error instanceof Error) {
            console.error(error.message);
          } else {
            console.error('An unknown error occurred');
          }
      return "error";
    }
  }

  export async function getAdRundates(element:string=""){
    
    const url = "/api/GetAdRundates?element=" + element;
    try{
      const response = await fetch(url,{
        headers:{
        },
        method:"GET"
       }
      );
      if (!response.ok) {
        throw new Error(`Response status: ${response.status}`);
      }else{            
        const data = await response.json();
        return data;
      }
    }
    catch(error){
        if (error instanceof Error) {
            console.error(error.message);
          } else {
            console.error('An unknown error occurred');
          }
      return "error";
    }
  }

  export async function addRunDate(newRundDate:NewLiveRunDate){
    const url = "/api/AddRunDate"
    const reqBody ={
      element:newRundDate.element,
      pub:newRundDate.pubNum,
      startDate:newRundDate.startDate.toLocaleDateString("en-US",{month:"2-digit",day:"2-digit",year:"numeric"}),
      endDate:newRundDate.endDate.toLocaleDateString("en-US",{month:"2-digit",day:"2-digit",year:"numeric"}),
    }
    const bodyStr = JSON.stringify(reqBody);
    console.log (bodyStr);
    try{
      const header = {
        headers: {
            'Content-Type': 'application/json'
        }
      }
      const response = await axios.post(url, bodyStr, header);

      //console.log(response);
      if (response.status!==200) {
        throw new Error(`Response status: ${response.status}`);
      }else{            
        return "200";
      }
    }
    catch(error){
        if (error instanceof Error) {
            console.error(error.message);
          } else {
            console.error('An unknown error occurred');
          }
      return "error";
    }
  }

  export async function deleteRunDate(newRundDate:RunDateToDelete){
    const url = "/api/DeleteRunDate"
    const reqBody ={
      element:newRundDate.element,
      pub:newRundDate.pubNum,
      startDate:newRundDate.startDate,
    }
    const bodyStr = JSON.stringify(reqBody);
    console.log (bodyStr);
    try{
      const header = {
        headers: {
            'Content-Type': 'application/json'
        }
      }
      const response = await axios.post(url, bodyStr, header);

      //console.log(response);
      if (response.status!==200) {
        throw new Error(`Response status: ${response.status}`);
      }else{            
        return "200";
      }
    }
    catch(error){
        if (error instanceof Error) {
            console.error(error.message);
          } else {
            console.error('An unknown error occurred');
          }
      return "error";
    }
  }


  export async function getAdHistory(element:string=""){
    
    const url = "/api/GetAdHistory?element=" + element;
    try{
      const response = await fetch(url,{
        headers:{
        },
        method:"GET"
       }
      );
      if (!response.ok) {
        throw new Error(`Response status: ${response.status}`);
      }else{            
        const data = await response.json();
        if (data==='401'){
          redirect("/login");
        }
        return data;
      }
    }
    catch(error){
        if (error instanceof Error) {
            console.error(error.message);
          } else {
            console.error('An unknown error occurred');
          }
      return "error";
    }
  }

  export async function getMMJobHistory(jobName:string=""){
    
    const url = "/api/GetMMJobHistory?jobName=" + jobName;
    try{
      const response = await fetch(url,{
        headers:{
        },
        method:"GET"
       }
      );
      if (!response.ok) {
        throw new Error(`Response status: ${response.status}`);
      }else{            
        const data = await response.json();
        return data;
      }
    }
    catch(error){
        if (error instanceof Error) {
            console.error(error.message);
          } else {
            console.error('An unknown error occurred');
          }
      return "error";
    }
  }


  export async function getMMToningBundle(path:string=""){
    
    const url = "/api/GetToningBundle?path=" + path;
    try{
      const response = await fetch(url,{
        headers:{
        },
        method:"GET"
       }
      );
      if (!response.ok) {
        throw new Error(`Response status: ${response.status}`);
      }else{            
        const data = await response.text();
        return data;
      }
    }
    catch(error){
        if (error instanceof Error) {
            console.error(error.message);
          } else {
            console.error('An unknown error occurred');
          }
      return "error";
    }
  }


  export async function getPackageData(site:string="", size:string=""){
    
    const url = "/api/GetPackageData?site=" + site + "&size=" + size;
    try{
      const response = await fetch(url,{
        headers:{
        },
        method:"GET"
       }
      );
      if (!response.ok) {
        throw new Error(`Response status: ${response.status}`);
      }else{            
        const data = await response.json();
        return data;
      }
    }
    catch(error){
        if (error instanceof Error) {
            console.error(error.message);
          } else {
            console.error('An unknown error occurred');
          }
      return "error";
    }
  }

  export async function getRMSizesRequested(element:string=""){
    
    const url = "/api/GetRMSizesRequested?element=" + element;
    try{
      const response = await fetch(url,{
        headers:{
        },
        method:"GET"
       }
      );
      if (!response.ok) {
        throw new Error(`Response status: ${response.status}`);
      }else{            
        const data = await response.json();
        return data;
      }
    }
    catch(error){
        if (error instanceof Error) {
            console.error(error.message);
          } else {
            console.error('An unknown error occurred');
          }
      return "error";
    }
  }

  export async function getAdSubelements(element:string="", elpath:string="", type=""){
    
    const url = "/api/GetAdSubelements?element=" + element + "&elpath=" + elpath + "&type=" + type;
    try{
      const response = await fetch(url,{
        headers:{
        },
        method:"GET"
       }
      );
      if (!response.ok) {
        throw new Error(`Response status: ${response.status}`);
      }else{            
        const data = await response.json();
        return data;
      }
    }
    catch(error){
        if (error instanceof Error) {
            console.error(error.message);
          } else {
            console.error('An unknown error occurred');
          }
      return "error";
    }
  }

  export async function getmmJobFiles(jobName:string="",){
    
    const url = "/api/GetMMJobFiles?jobName=" + jobName;
    try{
      const response = await fetch(url,{
        headers:{
        },
        method:"GET"
       }
      );
      if (!response.ok) {
        throw new Error(`Response status: ${response.status}`);
      }else{            
        const data = await response.json();
        return data;
      }
    }
    catch(error){
        if (error instanceof Error) {
            console.error(error.message);
          } else {
            console.error('An unknown error occurred');
          }
      return "error";
    }
  }


  export async function getAdJobTicket(element:string="", element_type:string="",slug:string="", site:string=""){
    
    const url = "/api/GetJobTicket?element=" + element+"&elementType="+element_type+"&slug="+slug+"&site="+site;
    try{
      const response = await fetch(url,{
        headers:{
        },
        method:"GET"
       }
      );
      if (!response.ok) {
        throw new Error(`Response status: ${response.status}`);
      }else{         
        const data = response.text();
        return data;
      }
    }
    catch(error){
        if (error instanceof Error) {
            console.error(error.message);
          } else {
            console.error('An unknown error occurred');
          }
    }
  }

  export async function getUserNotifications(username:string=""){
    
    const url = "/api/GetUserNotifications?username=" + username;
    try{
      const response = await fetch(url,{
        headers:{
        },
        method:"GET"
       }
      );
      if (!response.ok) {
        throw new Error(`Response status: ${response.status}`);
      }else{            
        const data = await response.json();
        return data;
      }
    }
    catch(error){
        if (error instanceof Error) {
            console.error(error.message);
          } else {
            console.error('An unknown error occurred');
          }
      return "error";
    }
  }

  export async function getAnimationPrompt(element:string="",size:string="", site:string=""){
    
    const url = "/api/GetAnimationPrompt?element="+element+"&site=" + site + "&size=" + size;
    try{
      const response = await fetch(url,{
        headers:{
        },
        method:"GET"
       }
      );
      if (!response.ok) {
        throw new Error(`Response status: ${response.status}`);
      }else{            
        const data = await response.json();
        return data;
      }
    }
    catch(error){
        if (error instanceof Error) {
            console.error(error.message);
          } else {
            console.error('An unknown error occurred');
          }
      return "error";
    }
  }

  export async function markUserNotificationsRead(username:string=""){
    
    const url = "/api/MarkUserNotificationsRead?username=" + username;
    try{
      const response = await fetch(url,{
        headers:{
        },
        method:"GET"
       }
      );
      if (!response.ok) {
        throw new Error(`Response status: ${response.status}`);
      }else{            
        const data = await response.json();
        return data;
      }
    }
    catch(error){
        if (error instanceof Error) {
            console.error(error.message);
          } else {
            console.error('An unknown error occurred');
          }
      return "error";
    }
  }

  export async function getProofFiles(element:string="", slug:string="", proofType:number=0, defDoc:string="", page:string="1",site:string=""){
    

    const url = "/api/GetProofFiles?element=" + element + "&slug=" + slug + "&proofType=" + proofType + "&defDoc=" + defDoc + "&page=" + page + "&site=" + site;
    //try{
      const response = await fetch(url,{
        method:"GET"
       }
      );
      if (!response.ok) {
        throw new Error(`Response status: ${response.status}`);
      }else{            
        const data = await response.json();
        return data;
      }
    //}
    // catch(error){
    //     if (error instanceof Error) {
    //         console.error(error.message);
    //       } else {
    //         console.error('An unknown error occurred');
    //       }
    //   return "error";
    // }
  }

  export async function deleteUserQuery(queryNum:string=""){
    
    const url = "/api/DeleteUserQuery?qNum=" + queryNum;
    try{
      const response = await fetch(url,{
        headers:{
        },
        method:"GET"
       }
      );
      if (!response.ok) {
        throw new Error(`Response status: ${response.status}`);
      }else{            
        const data = await response.text();
        return data;
      }
    }
    catch(error){
        if (error instanceof Error) {
            console.error(error.message);
          } else {
            console.error('An unknown error occurred');
          }
      return "error";
    }
  }

  export async function translateText(source:string="", target:string="", content:string=""){
    

    const reqBody = {
      source:source,
      target:target,
      text:content
    }

    console.log(reqBody);
    const url = "/api/TranslateText"
    const bodyStr = JSON.stringify(reqBody);
    console.log (bodyStr);
    try{
      const response = await fetch(url,{
        method:"POST",
        headers:{
          "Content-Type":"application/json"
        },
        body: bodyStr
       }
      );
      //console.log(response);
      if (!response.ok) {
        throw new Error(`Response status: ${response.status}`);
      }else{            
        const data = await response.text();
        return data;
      }
    }
    catch(error){
        if (error instanceof Error) {
            console.error(error.message);
          } else {
            console.error('An unknown error occurred');
          }
      return "error";
    }
  }

  export async function approveAd(adToApprove:AdToApprove){
    const url = "/api/ApproveAd"
    const bodyStr = JSON.stringify(adToApprove);
    console.log (bodyStr);
    try{
      const response = await fetch(url,{
        method:"POST",
        headers:{
          "Content-Type":"application/json"
        },
        body: bodyStr
       }
      );
      if (!response.ok) {
        throw new Error(`Response status: ${response.status}`);
      }else{            
        const data = await response.text();
        return data;
      }
    }
    catch(error){
        if (error instanceof Error) {
            console.error(error.message);
          } else {
            console.error('An unknown error occurred');
          }
      return "error";
    }
  }

  export async function getAccountNotes(account:string=""){
    
    const url = "/api/GetAccountNotes?account=" + account;
    try{
      const response = await fetch(url,{
        headers:{
        },
        method:"GET"
       }
      );
      console.log(response);
      if (!response.ok) {
        throw new Error(`Response status: ${response.status}`);
      }else{            
        const data = await response.json();
        return data;
      }
    }
    catch(error){
        if (error instanceof Error) {
            console.error(error.message);
          } else {
            console.error('An unknown error occurred');
          }
      return "error";
    }
  }

  export async function getPickupList(account:string="", adType:string="", ad:string="", category:string=""){
    
    const url = "/api/GetPickupList?account=" + account + "&ad=" + ad + "&adType=" + adType + "&category=" + category; 
    try{
      const response = await fetch(url,{
        headers:{
        },
        method:"GET"
       }
      );
      console.log(response);
      if (!response.ok) {
        throw new Error(`Response status: ${response.status}`);
      }else{            
        const data = await response.json();
        return data;
      }
    }
    catch(error){
        if (error instanceof Error) {
            console.error(error.message);
          } else {
            console.error('An unknown error occurred');
          }
      return "error";
    }
  }

  export async function getPickupToList(account:string="", adType:string=""){
    
    const url = "/api/GetAdsForCustomer?account=" + account + "&type=" + adType; 
    try{
      const response = await fetch(url,{
        headers:{
        },
        method:"GET"
       }
      );
      console.log(response);
      if (!response.ok) {
        throw new Error(`Response status: ${response.status}`);
      }else{            
        const data = await response.json();
        return data;
      }
    }
    catch(error){
        if (error instanceof Error) {
            console.error(error.message);
          } else {
            console.error('An unknown error occurred');
          }
      return "error";
    }
  }

  export async function getDeadlines(element:string=""){
    
    const url = "/api/GetDeadlines?element=" + element; 
    try{
      const response = await fetch(url,{
        headers:{
        },
        method:"GET"
       }
      );
      console.log(response);
      if (!response.ok) {
        throw new Error(`Response status: ${response.status}`);
      }else{            
        const data = await response.json();
        return data;
      }
    }
    catch(error){
        if (error instanceof Error) {
            console.error(error.message);
          } else {
            console.error('An unknown error occurred');
          }
      return "error";
    }
  }


  export async function getFormFields(oType:string="", adType:string="", site:string="", pr:boolean=false, cat:string="", trusted:string="1",segment:string=""){
    
    const url = "/api/GetFormFields?oType="+oType+"&adType="+adType+"&site="+site+"&pr="+pr+"&cat="+cat+"&trusted="+trusted+"&segment="+segment; 
    console.log(url);
    try{
      const response = await fetch(url,{
        headers:{
        },
        method:"GET"
       }
      );
      //console.log(response);
      if (!response.ok) {
        throw new Error(`Response status: ${response.status}`);
      }else{            
        const data = await response.json();
        return data;
      }
    }
    catch(error){
        if (error instanceof Error) {
            console.error(error.message);
          } else {
            console.error('An unknown error occurred');
          }
      return "error";
    }
  }


  export async function getFormResponses(element:string=""){
    
    const url = "/api/GetFormResponses?element="+element; 
    console.log(url);
    try{
      const response = await fetch(url,{
        headers:{
        },
        method:"GET"
       }
      );
      //console.log(response);
      if (!response.ok) {
        throw new Error(`Response status: ${response.status}`);
      }else{            
        const data = await response.json();
        return data;
      }
    }
    catch(error){
        if (error instanceof Error) {
            console.error(error.message);
          } else {
            console.error('An unknown error occurred');
          }
      return "error";
    }
  }

  export async function getFieldsDisplay(status:string=""){
    
    const url = "/api/GetFieldDisplay?status="+status; 
    console.log(url);
    try{
      const response = await fetch(url,{
        headers:{
        },
        method:"GET"
       }
      );
      //console.log(response);
      if (!response.ok) {
        throw new Error(`Response status: ${response.status}`);
      }else{            
        const data = await response.json();
        return data;
      }
    }
    catch(error){
        if (error instanceof Error) {
            console.error(error.message);
          } else {
            console.error('An unknown error occurred');
          }
      return "error";
    }
  }


  export async function addWatchList(element:string=""){
    
    const url = "/api/AddWatchList?element=" + element;
    try{
      const response = await fetch(url,{
        headers:{
        },
        method:"GET"
       }
      );
      console.log(response);
      if (!response.ok) {
        throw new Error(`Response status: ${response.status}`);
      }else{            
        const data = await response.json();
        return data;
      }
    }
    catch(error){
        if (error instanceof Error) {
            console.error(error.message);
          } else {
            console.error('An unknown error occurred');
          }
      return "error";
    }
  }

  export async function removeWatchList(element:string=""){
    
    const url = "/api/RemoveWatchList?element=" + element;
    try{
      const response = await fetch(url,{
        headers:{
        },
        method:"GET"
       }
      );
      console.log(response);
      if (!response.ok) {
        throw new Error(`Response status: ${response.status}`);
      }else{            
        const data = await response.json();
        return data;
      }
    }
    catch(error){
        if (error instanceof Error) {
            console.error(error.message);
          } else {
            console.error('An unknown error occurred');
          }
      return "error";
    }
  }


  export async function pingAuth(){
    interface PingAuthResponse {
      ok: boolean;
    }
    const url = "/api/PingAuth";
    const response: PingAuthResponse = await fetch(url, { method: "GET" });
    if (!response.ok) {
        window.location.href = "/login";
    }    
}

export async function getAIAdCopyStyles(){
    
  const url = "/api/GetAIAdCopyStyles";
  try{
    const response = await fetch(url,{
      headers:{
      },
      method:"GET"
     }
    );
    console.log(response);
    if (!response.ok) {
      throw new Error(`Response status: ${response.status}`);
    }else{            
      const data = await response.json();
      return data;
    }
  }
  catch(error){
      if (error instanceof Error) {
          console.error(error.message);
        } else {
          console.error('An unknown error occurred');
        }
    return "error";
  }
}

export async function getAIAdCopyActions(account:string=""){
    
  const url = "/api/GetAIAdCopyActions";
  try{
    const response = await fetch(url,{
      headers:{
      },
      method:"GET"
     }
    );
    console.log(response);
    if (!response.ok) {
      throw new Error(`Response status: ${response.status}`);
    }else{            
      const data = await response.json();
      return data;
    }
  }
  catch(error){
      if (error instanceof Error) {
          console.error(error.message);
        } else {
          console.error('An unknown error occurred');
        }
    return "error";
  }
}

export async function getAIActionUnitOptions(aiAction:string=""){
    
  const url = "/api/GetAIActionUnitOptions?aiAction=" + aiAction;
  try{
    const response = await fetch(url,{
      headers:{
      },
      method:"GET"
     }
    );
    console.log(response);
    if (!response.ok) {
      throw new Error(`Response status: ${response.status}`);
    }else{            
      const data = await response.json();
      return data;
    }
  }
  catch(error){
      if (error instanceof Error) {
          console.error(error.message);
        } else {
          console.error('An unknown error occurred');
        }
    return "error";
  }
}

export async function GetOpenAIResponse(prompt:string="", maxTokens:number ){
    
  const url = "/api/GetOpenAIResponse?prompt=" + prompt + "&maxTokens=" + maxTokens;
  try{
    const response = await fetch(url,{
      headers:{
      },
      method:"GET"
     }
    );
    console.log(response);
    if (!response.ok) {
      throw new Error(`Response status: ${response.status}`);
    }else{            
      const data = await response.json();
      return data;
    }
  }
  catch(error){
      if (error instanceof Error) {
          console.error(error.message);
        } else {
          console.error('An unknown error occurred');
        }
    return "error";
  }
}

export async function getAIMessageBody(type:string=""){
    
    const url = "/api/GetAIMessageBody?type=" + type;
    try{
      const response = await fetch(url,{
        headers:{
        },
        method:"GET"
       }
      );
      if (!response.ok) {
        throw new Error(`Response status: ${response.status}`);
      }else{            
        const data = await response.json();
        return data;
      }
    }
    catch(error){
        if (error instanceof Error) {
            console.error(error.message);
          } else {
            console.error('An unknown error occurred');
          }
      return "error";
    }
  }
export async function getAdExists(element:string=""){
  const url = "/api/GetAdExists?element=" + element;
  try{
    const response = await fetch(url,{
      headers:{
      },
      method:"GET"
     }
    );
    console.log(response);
    
    if (!response.ok) {
      throw new Error(`Response status: ${response.status}`);
    }else{            
      const data = await response.json();
      return data;
    }
  }
  catch(error){
      if (error instanceof Error) {
          console.error(error.message);
        } else {
          console.error('An unknown error occurred');
        }
    return "error";
  }
}


export async function getAdCreated(element:string=""){
  const url = "/api/GetAdCreated?element=" + element;
  try{
    const response = await fetch(url,{
      headers:{
      },
      method:"GET"
     }
    );
    console.log(response);
    
    if (!response.ok) {
      throw new Error(`Response status: ${response.status}`);
    }else{            
      const data = await response.json();
      return data;
    }
  }
  catch(error){
      if (error instanceof Error) {
          console.error(error.message);
        } else {
          console.error('An unknown error occurred');
        }
    return "error";
  }
}

export async function getStat2Value(element:string="", field:string=""){
  const url = "/api/GetStat2Value?element=" + element + "&field="+field;
  try{
    const response = await fetch(url,{
      headers:{
      },
      method:"GET"
     }
    );
    console.log(response);
    
    if (!response.ok) {
      throw new Error(`Response status: ${response.status}`);
    }else{            
      const data = await response.json();
      return data;
    }
  }
  catch(error){
      if (error instanceof Error) {
          console.error(error.message);
        } else {
          console.error('An unknown error occurred');
        }
    return "error";
  }
}

export async function getSiteFlag(site:string){
  const url = "/api/GetSiteFlag?sitecode=" + site;
  try{
    const response = await fetch(url,{
      headers:{
      },
      method:"GET"
     }
    );
    console.log(response);
    
    if (!response.ok) {
      throw new Error(`Response status: ${response.status}`);
    }else{            
      const data = await response.json();
      return data;
    }
  }
  catch(error){
      if (error instanceof Error) {
          console.error(error.message);
        } else {
          console.error('An unknown error occurred');
        }
    return "error";
  }
}

export async function getShareLinkUrl(element:string,embed:boolean=false, ticket:boolean=false){
  const url = "/api/GetShareLinkURL?element=" + element + "&embed=" + embed + "&ticket=" + ticket;
  console.log(url);
  try{
    const response = await fetch(url,{
      headers:{
      },
      method:"GET"
     }
    );    
    if (!response.ok) {
      throw new Error(`Response status: ${response.status}`);
    }else{            
      const data = await response.json();
      return data;
    }
  }
  catch(error){
      if (error instanceof Error) {
          console.error(error.message);
        } else {
          console.error('An unknown error occurred');
        }
    return "error";
  }
}

export async function processSubmission(fields:SubToProcess){ 

  console.log(fields);
  const url = "/api/ProcessSubmission";
  try{
    const jsonField = JSON.stringify(fields);
    console.log(jsonField);
    const header = {
      headers: {
          'Content-Type': 'application/json'
      }
    }
    const response = await axios.post(url, jsonField, header);
    if (response.status!==200) {
      throw new Error(`Response status: ${response.status}`);
    }else{            
      //const data = await response.();
      return "200";
    }
  }
  catch(error){
       if (error instanceof Error) {
           console.error(error.message);
         } else {
           console.error('An unknown error occurred');
         }
    return [];
   }
}

export async function writeToHistory(fields:HistoryEntry){ 

  console.log(fields);
  const url = "/api/WriteToHistory";
  try{
    const jsonField = JSON.stringify(fields);
    console.log(jsonField);
    const header = {
      headers: {
          'Content-Type': 'application/json'
      }
    }
    const response = await axios.post(url, jsonField, header);
    if (response.status!==200) {
      throw new Error(`Response status: ${response.status}`);
    }else{            
      //const data = await response.();
      return "200";
    }
  }
  catch(error){
       if (error instanceof Error) {
           console.error(error.message);
         } else {
           console.error('An unknown error occurred');
         }
    return [];
   }
}

export async function saveAnnotations(notes:ImageAnnotation[], element:string, color:string, user:string){
  var AnnotationList:ATOLAnnotation[]=[];
  //parse the annotations
  notes.forEach(note=>{
    var anno:ATOLAnnotation = {
      tagid:note.id,
      element:element,
      x: (note.target.selector.geometry as any).x.toString(),
      y: (note.target.selector.geometry as any).y.toString(),
      h: (note.target.selector.geometry as any).h.toString(),
      w: (note.target.selector.geometry as any).w.toString(),
      tag_comment:note.bodies[0].value||"",
      tag_status:0,
      time_stamp:"",
      user_name:user,
      comp_user:"",
      comp_time:"",
      spot_color:color,
      text_color:note.bodies[0].id,
      spot_circle:"false",
      page:"1"
    }
    AnnotationList.push(anno);
  });
  console.log(AnnotationList);
  const url = "/api/SaveAnnotations";
  try{    
    const jsonField = JSON.stringify(AnnotationList);
    console.log("Notations to save:");
    console.log(jsonField);
    const header = {
      headers: {
          'Content-Type': 'application/json'
      }
    }
    const response = await axios.post(url, jsonField, header);
    if (response.status!==200) {
      throw new Error(`Response status: ${response.status}`);
    }else{            
      //const data = await response.();
      return "200";
    }
  }
  catch(error){
       if (error instanceof Error) {
           console.error(error.message);
         } else {
           console.error('An unknown error occurred');
         }
    return [];
   }


}

export async function getAnnotations(element:string, filter:string){
  const url = "/api/GetAdAnnotations?element=" + element;
  try{
    const response = await fetch(url,{
      headers:{
      },
      method:"GET"
     }
    );
    if (!response.ok) {
      throw new Error(`Response status: ${response.status}`);
    }else{            
      const data:ATOLAnnotation[] = await response.json();
      //console.log(data);
      const dataFilter = ()=>{
        switch(filter){
          case "0":
            return 0;
            break;
          case "1":
            return 1;
            break;
          case "2":
            return 2;
            break;
          case "3":
            return 99;
            break;
          default:
            return 99;
            break;
        }
      }
      
      var annotationList:ImageAnnotation[]=[];
      const filterValue = dataFilter();
      var addAnno=true;
      for (const anno of data) {
        if (filterValue !== 99 && anno.tag_status === filterValue){
          addAnno=true;
        }else{
          if (filterValue===99){
            addAnno=true;
          }else{
            addAnno=false;
          }
        }
        if (addAnno){
          const longDateTime:longDateTime = {
              year:anno.time_stamp.substring(0,4),
              month:anno.time_stamp.substring(4,6),
              day:anno.time_stamp.substring(6,8),
              hour:anno.time_stamp.substring(8,10),
              minute:anno.time_stamp.substring(10,12),
              second:anno.time_stamp.substring(12,14),
          }
          //console.log(longDateTime);
          const newDateTime=new Date(longDateTime.month+"/"+longDateTime.day+"/"+longDateTime.year +" "+ longDateTime.hour + ":" + longDateTime.minute + ":" + longDateTime.second);
          //console.log(newDateTime);
          const x = parseFloat(anno.x);
          const y = parseFloat(anno.y);
          const w = parseFloat(anno.w);
          const h = parseFloat(anno.h)
          const maxX = parseFloat(anno.x) + parseFloat(anno.w);
          const MaxY = parseFloat(anno.y) + parseFloat(anno.h);

          const newAnnotation: ImageAnnotation = {
            id: anno.tagid,
            bodies: [
              {
                id: anno.text_color,
                annotation: anno.tagid,
                purpose: "commenting",
                value: anno.tag_comment,
                creator: { name: "", id: anno.user_name },
              },
            ],
            target: {
              annotation: anno.tagid,
              selector: {
                type: 'RECTANGLE' as ShapeType,
                geometry: {
                  bounds: {
                    minX: x,
                    minY: y,
                    maxX: maxX,
                    maxY: MaxY,
                  },
                  x:x,
                  y:y,
                  h:h,
                  w:w
                },
              },
              creator: { name: "", id: anno.user_name },
              created: newDateTime,
            }
          };
          annotationList.push(newAnnotation);
        }        
      }
      //console.log(annotationList);
      return annotationList;
    }
  }
  catch(error){
      if (error instanceof Error) {
          console.error(error.message);
        } else {
          console.error('An unknown error occurred');
        }
    return "error";
  }

}

export async function setAnnotationStatus(tagID:string,status:number){

   const url = "/api/SetAnnotationStatus?tagid=" + tagID + "&tagStatus=" + status;
  try{
    const response = await fetch(url,{
      headers:{
      },
      method:"GET"
     }
    );
    console.log(response);
    
    if (!response.ok) {
      throw new Error(`Response status: ${response.status}`);
    }else{            
      const data = await response.json();
      
      console.log (data);
    }
  }
  catch(error){
      if (error instanceof Error) {
          console.error(error.message);
        } else {
          console.error('An unknown error occurred');
        }
    return "error";
  }

}

export async function getNextAd(){
  const url = "/api/GetNextAd";
  try{
    const response = await fetch(url,{
      headers:{
      },
      method:"GET"
     }
    );
    console.log(response);
    
    if (!response.ok) {
      throw new Error(`Response status: ${response.status}`);
    }else{            
      const data = await response.json();
      
      console.log (data);
    }
  }
  catch(error){
      if (error instanceof Error) {
          console.error(error.message);
        } else {
          console.error('An unknown error occurred');
        }
    return "error";
  }
}

export async function releaseGetNext(element:string){
  const url = "/api/ReleaseGetNext?element=" + element;
  try{
    const response = await fetch(url,{
      headers:{
      },
      method:"GET"
     }
    );
    console.log(response);
    
    if (!response.ok) {
      throw new Error(`Response status: ${response.status}`);
    }else{            
      const data = await response.json();
      console.log (data);
    }
  }
  catch(error){
      if (error instanceof Error) {
          console.error(error.message);
        } else {
          console.error('An unknown error occurred');
        }
    return "error";
  }
}

export async function sendMailMessage(mailMessage:mailMessage){
  const url = "/api/SendMailMessage";
  try{    
    const jsonField = JSON.stringify(mailMessage);
    console.log(jsonField);
    const header = {
      headers: {
          'Content-Type': 'application/json'
      }
    }
    const response = await axios.post(url, jsonField, header);
    if (response.status!==200) {
      throw new Error(`Response status: ${response.status}`);
    }else{            
      return "200";
    }
  }
  catch(error){
       if (error instanceof Error) {
           console.error(error.message);
         } else {
           console.error('An unknown error occurred');
         }
    return [];
   }
}

export async function saveUser(user:atolUser, type:string){
  if (user.userName===""){
    await getUniqueUserName(user.temp2).then(data=>{
      user.userName=data;
    })
  }
  const url = "/api/SaveUser";
  try{    
    const jsonField = JSON.stringify(user);
    console.log(jsonField);
    const header = {
      headers: {
          'Content-Type': 'application/json'
      }
    }
    user.salt=0;
    user.associations="";
    const response = await axios.post(url, user, header);
    if (response.status!==200) {
      throw new Error(`Response status: ${response.status}`);
    }else{           
      return "200";
    }
  }
  catch(error){
        if (error instanceof Error) {
            console.error(error.message);
          } else {
            console.error('An unknown error occurred');
          }
    return [];
  }  
  
  
}

export async function getUniqueUserName(account:string){
  const url = "/api/GetUniqueUserName?account=" + account;
  try{
    const response = await fetch(url,{
      headers:{
      },
      method:"GET"
     }
    );
    console.log(response);
    if (!response.ok) {
      throw new Error(`Response status: ${response.status}`);
    }else{            
      const data = await response.json();
      return data;
    }
  }
  catch(error){
      if (error instanceof Error) {
          console.error(error.message);
        } else {
          console.error('An unknown error occurred');
        }
    return "error";
  }
}

export async function getNotesList(element:string){
  const url = "/api/GetNotesList?element=" + element;
  try{
    const response = await fetch(url,{
      headers:{
      },
      method:"GET"
     }
    );
    if (!response.ok) {
      throw new Error(`Response status: ${response.status}`);
    }else{            
      const data:ATOLAnnotation[] = await response.json();
      return data;
    }
  }
  catch(error){
      if (error instanceof Error) {
          console.error(error.message);
        } else {
          console.error('An unknown error occurred');
        }
    return "error";
  }

}

export async function getAdsForBulkEmail(element:string, account:string, status:string){

  const url = "/api/GetAdsForBulkEmail?element=" + element + "&account=" + account + "&status=" + status;
  try{
    const response = await fetch(url,{
      headers:{
      },
      method:"GET"
     }
    );
    if (!response.ok) {
      throw new Error(`Response status: ${response.status}`);
    }else{            
      const data= await response.json();
      return data;
    }
  }
  catch(error){
      if (error instanceof Error) {
          console.error(error.message);
        } else {
          console.error('An unknown error occurred');
        }
    return "error";
  }

}

export async function getUserListToAssociate(searchValue:string){

  const url = "/api/GetUserListToAssociate?site=All&userType=3C&searchField=fullName&searchValue=" + searchValue;
  try{
    const response = await fetch(url,{
      headers:{
      },
      method:"GET"
     }
    );
    if (!response.ok) {
      throw new Error(`Response status: ${response.status}`);
    }else{            
      const data= await response.json();
      return data;
    }
  }
  catch(error){
      if (error instanceof Error) {
          console.error(error.message);
        } else {
          console.error('An unknown error occurred');
        }
    return "error";
  }

}

export async function addUserAssociation(fields:userAssociation){ 

    console.log(fields);
    const url = "/api/AddUserAssociation";
     try{
      const response = await fetch(url,{
         headers:{
          "Content-Type": "application/json"
         },
         method:"POST",
         body:JSON.stringify(fields)
        }
       );
       if (!response.ok) {
         throw new Error(`Response status: ${response.status}`);
       }else{            
         //const data = await response.text();
         return "success";
       }
     }
     catch(error){
         if (error instanceof Error) {
             console.error(error.message);
           } else {
             console.error('An unknown error occurred');
           }
      return [];
     }
  }

export async function getUserRollUpGroups(username:string=""){
  
  var url = "/api/GetUserRollUpGroups";
  if (username!=""){
    url+="?username="+username;
  }
  try{
    const response = await fetch(url,{
      headers:{
      },
      method:"GET"
      }
    );
    if (!response.ok) {
      throw new Error(`Response status: ${response.status}`);
    }else{            
      const data = await response.json();
      return data;
    }
  }
  catch(error){
      if (error instanceof Error) {
          console.error(error.message);
        } else {
          console.error('An unknown error occurred');
        }
    return "error";
  }
}

export async function getTrafficUserList(){
  
  const url = "/api/GetTrafficUserList";
  try{
    const response = await fetch(url,{
      headers:{
      },
      method:"GET"
      }
    );
    if (!response.ok) {
      throw new Error(`Response status: ${response.status}`);
    }else{            
      const data = await response.json();
      return data;
    }
  }
  catch(error){
      if (error instanceof Error) {
          console.error(error.message);
        } else {
          console.error('An unknown error occurred');
        }
    return "error";
  }
}

export async function getTrafficStatusList(){
  
  const url = "/api/GetTrafficStatusList";
  try{
    const response = await fetch(url,{
      headers:{
      },
      method:"GET"
      }
    );
    if (!response.ok) {
      throw new Error(`Response status: ${response.status}`);
    }else{            
      const data = await response.json();
      return data;
    }
  }
  catch(error){
      if (error instanceof Error) {
          console.error(error.message);
        } else {
          console.error('An unknown error occurred');
        }
    return "error";
  }
}

export async function getTrafficCCSubStatusList(){
  
  const url = "/api/GetTrafficCCSubStatusList";
  try{
    const response = await fetch(url,{
      headers:{
      },
      method:"GET"
      }
    );
    if (!response.ok) {
      throw new Error(`Response status: ${response.status}`);
    }else{            
      const data = await response.json();
      return data;
    }
  }
  catch(error){
      if (error instanceof Error) {
          console.error(error.message);
        } else {
          console.error('An unknown error occurred');
        }
    return "error";
  }
}


export async function fillTrafficGrid(group:string="", filter:number=0, pagDate:string="", pagEndDate:string=""){ 
    const url = "/api/FillTrafficList?group=" + group + "&filter=" + filter.toString() +"&pagDate="+ pagDate + "&pagEndDate="+pagEndDate;
    try{
      const response = await fetch(url,{
        headers:{
        },
        method:"GET"
       }
      );
      if (!response.ok) {
        throw new Error(`Response status: ${response.status}`);
      }else{            
        const data = await response.json();
        return data;
      }
    }
    catch(error){
        if (error instanceof Error) {
            console.error(error.message);
          } else {
            console.error('An unknown error occurred');
          }
      return [];
    }
}

export async function getTrafficNotes(element:string){
    const url = "/api/GetTrafficNotes?element=" + element;
    try{
      const response = await fetch(url,{
        headers:{
        },
        method:"GET"
       }
      );
      if (!response.ok) {
        throw new Error(`Response status: ${response.status}`);
      }else{            
        const data = await response.json();
        return data;
      }
    }
    catch(error){
        if (error instanceof Error) {
            console.error(error.message);
          } else {
            console.error('An unknown error occurred');
          }
      return [];
    }
}

export async function getHoldNotes(element:string){
    const url = "/api/GetHoldNotes?element=" + element;
    try{
      const response = await fetch(url,{
        headers:{
        },
        method:"GET"
       }
      );
      if (!response.ok) {
        throw new Error(`Response status: ${response.status}`);
      }else{            
        const data = await response.json();
        return data;
      }
    }
    catch(error){
        if (error instanceof Error) {
            console.error(error.message);
          } else {
            console.error('An unknown error occurred');
          }
      return [];
    }
}

export async function getProofNotes(element:string){
    const url = "/api/GetProofNotes?element=" + element;
    try{
      const response = await fetch(url,{
        headers:{
        },
        method:"GET"
       }
      );
      if (!response.ok) {
        throw new Error(`Response status: ${response.status}`);
      }else{            
        const data = await response.json();
        return data;
      }
    }
    catch(error){
        if (error instanceof Error) {
            console.error(error.message);
          } else {
            console.error('An unknown error occurred');
          }
      return [];
    }
}

export async function saveTrafficNote(newNote:trafficNote){
console.log(newNote);
  const url = "/api/SaveTrafficNote";
    try{
    const response = await fetch(url,{
        headers:{
        "Content-Type": "application/json"
        },
        method:"POST",
        body:JSON.stringify(newNote)
      }
      );
      if (!response.ok) {
        throw new Error(`Response status: ${response.status}`);
      }else{            
        //const data = await response.text();
        return "success";
      }
    }
    catch(error){
        if (error instanceof Error) {
            console.error(error.message);
          } else {
            console.error('An unknown error occurred');
          }
    return [];
    }
}

export async function updateTraffic(element:string,field:string,value:string){
  const url = "/api/UpdateTraffic";
  var formData = {
    element:element,
    field:field,
    value:value
  }
    try{
      const response = await fetch(url,{
        headers:{
        "Content-Type": "application/json"
        },
        method:"POST",
        body:JSON.stringify(formData)
      }
      );
      if (!response.ok) {
        throw new Error(`Response status: ${response.status}`);
      }else{            
        //const data = await response.text();
        return "success";
      }
    }
    catch(error){
        if (error instanceof Error) {
            console.error(error.message);
          } else {
            console.error('An unknown error occurred');
          }
    return [];
    }
}

export async function fillToningJobList(archive:number=0, search:string=""){
    const url = "/api/GetMMToningJobs?archive=" + archive + "&search=" + search;
    try{
      const response = await fetch(url,{
        headers:{
        },
        method:"GET"
       }
      );
      if (!response.ok) {
        throw new Error(`Response status: ${response.status}`);
      }else{            
        const data = await response.json();
        return data;
      }
    }
    catch(error){
        if (error instanceof Error) {
            console.error(error.message);
          } else {
            console.error('An unknown error occurred');
          }
      return [];
    }
}

export async function getMMSites(){
    
  const url = "/api/GetMMSites";
  try{
    const response = await fetch(url,{
      headers:{
      },
      method:"GET"
      }
    );
    if (!response.ok) {
      throw new Error(`Response status: ${response.status}`);
    }else{            
      const data = await response.json();
      return data;
    }
  }
  catch(error){
      if (error instanceof Error) {
          console.error(error.message);
        } else {
          console.error('An unknown error occurred');
        }
    return "error";
  }
}

export async function getMMCOBType(){
    
  const url = "/api/GetMMCOBType";
  try{
    const response = await fetch(url,{
      headers:{
      },
      method:"GET"
      }
    );
    if (!response.ok) {
      throw new Error(`Response status: ${response.status}`);
    }else{            
      const data = await response.json();
      return data;
    }
  }
  catch(error){
      if (error instanceof Error) {
          console.error(error.message);
        } else {
          console.error('An unknown error occurred');
        }
    return "error";
  }
}

export async function getMMColorOptions(){
    
  const url = "/api/GetMMColorOptions";
  try{
    const response = await fetch(url,{
      headers:{
      },
      method:"GET"
      }
    );
    if (!response.ok) {
      throw new Error(`Response status: ${response.status}`);
    }else{            
      const data = await response.json();
      return data;
    }
  }
  catch(error){
      if (error instanceof Error) {
          console.error(error.message);
        } else {
          console.error('An unknown error occurred');
        }
    return "error";
  }
}
export async function getMMJobTypes(){
    
  const url = "/api/GetMMJobTypes";
  try{
    const response = await fetch(url,{
      headers:{
      },
      method:"GET"
      }
    );
    if (!response.ok) {
      throw new Error(`Response status: ${response.status}`);
    }else{            
      const data = await response.json();
      return data;
    }
  }
  catch(error){
      if (error instanceof Error) {
          console.error(error.message);
        } else {
          console.error('An unknown error occurred');
        }
    return "error";
  }
}
export async function getMMTurnTimes(){
    
  const url = "/api/GetMMTurnTimes";
  try{
    const response = await fetch(url,{
      headers:{
      },
      method:"GET"
      }
    );
    if (!response.ok) {
      throw new Error(`Response status: ${response.status}`);
    }else{            
      const data = await response.json();
      return data;
    }
  }
  catch(error){
      if (error instanceof Error) {
          console.error(error.message);
        } else {
          console.error('An unknown error occurred');
        }
    return "error";
  }
}

export async function getMMReturnFormat(){
    
  const url = "/api/GetMMReturnFormat";
  try{
    const response = await fetch(url,{
      headers:{
      },
      method:"GET"
      }
    );
    if (!response.ok) {
      throw new Error(`Response status: ${response.status}`);
    }else{            
      const data = await response.json();
      return data;
    }
  }
  catch(error){
      if (error instanceof Error) {
          console.error(error.message);
        } else {
          console.error('An unknown error occurred');
        }
    return "error";
  }
}

export async function getMMToningPresets(site:string){
    
  const url = "/api/GetMMToningPresets?site="+site;
  try{
    const response = await fetch(url,{
      headers:{
      },
      method:"GET"
      }
    );
    if (!response.ok) {
      throw new Error(`Response status: ${response.status}`);
    }else{            
      const data = await response.json();
      return data;
    }
  }
  catch(error){
      if (error instanceof Error) {
          console.error(error.message);
        } else {
          console.error('An unknown error occurred');
        }
    return "error";
  }
}


export async function submitToningRequest(request:ToningRequest){
  console.log(request);
  const formData: Record<string, any> = {};
  formData["tnPath"] = "";
  //const tnSiteCode = request.tnSiteCode as unknown as { mmSiteCode: string };
  formData["tnSiteCode"] = (JSON.parse(request.tnSiteCode).mmSiteCode);
  formData["tnPreset"] = (JSON.parse(request.tnPreset).mmToningPresetName);
  formData["tnDueWithin"] = (JSON.parse(request.tnDueWithin).mmMins.toString());
  formData["tnJobType"] = (JSON.parse(request.tnJobType).mmJobType);
  formData["tnReturnType"] = "";
  formData["tnColor"] = (JSON.parse(request.tnColor).mmColorValue);
  formData["tnCropping"] = request.tnCropping;
  formData["tnCroppingX"] = request.tnCroppingX;
  formData["tnCroppingY"] = request.tnCroppingY;
  formData["tnCOBType"] = (JSON.parse(request.tnCOBType).mmCOBType);
  formData["tnReturnFormat"] = (JSON.parse(request.tnReturnFormat).mmReturnFormat);
  formData["tnReturnRes"] = request.tnReturnRes;
  formData["tnInstructions"] = request.tnInstructions;
  formData["tnJobDescription"] = request.tnJobDescription;
  formData["tnCustomer"] = "";
  //formData["tnFileList"] = request.tnFileList;
  if (request.tnFileList.length > 0) {
      var fileNames: string[] = [];
      request.tnFileList.forEach(function (file) {
          console.log(file["name"]);
          var oldname = file["name"];
          var newname = oldname.replace(/(&.+;)/ig, '_');
          console.log(newname);
          fileNames.push(newname);
      });
      console.log(fileNames);
      formData["tnFileList"] = fileNames;
      const url = "/api/SubmitToningRequest";
      try{
        const jsonField = JSON.stringify(formData);
        console.log(jsonField);
        const header = {
          headers: {
              'Content-Type': 'application/json'
          }
        }
        const response = await axios.post(url, jsonField, header);
        if (response.status!==200) {
          throw new Error(`Response status: ${response.status}`);
          
        }else{            
          //const data = await response.();
          const data = await response.data;
          console.log(data);
          const mmUploadData=new FormData();
          var uploadData = new FormData();
          for (const file of request.tnFileList as UploadFileInfo[]) {
            if (file.getRawFile){
              uploadData.append("mmFileUpload", file.getRawFile(), file.name);
            }
          }
          //const jobList:toningJob[] = JSON.parse(data);          
          uploadData.append("jobList", JSON.stringify(data));
          const url = "/api/UploadMMFiles";
          const header = {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
          }
          const upResponse = await axios.post(url, uploadData, header);
          if (upResponse.status!==200) {
            throw new Error(`Response status: ${upResponse.status}`);
          }else{    
            const data = await upResponse.data;
            console.log(data); 
            //const fileData: Record<string, any> = {};
            return "200";
          }
        }
      }
      catch(error){
          if (error instanceof Error) {
              console.error(error.message);
            } else {
              console.error('An unknown error occurred');
            }
        return [];
      }
    }
}

export async function makeHotRush(element:string, hotRush:number=0, rushType:number=0){
  const url = "/api/MakeHotRush?element=" + element + "&hotrush=" + hotRush + "&rushType=" + rushType;
  try{
    const response = await fetch(url,{
      headers:{
      },
      method:"GET"
     }
    );
    console.log(response);
    
    if (!response.ok) {
      throw new Error(`Response status: ${response.status}`);
    }else{            
      const data = await response.json();
      return data;
    }
  }
  catch(error){
      if (error instanceof Error) {
          console.error(error.message);
        } else {
          console.error('An unknown error occurred');
        }
    return "error";
  }
}

export async function validateEmailLink(element:string, viewcode:string){
    
  const url = "/api/ValidateEmailLink?element="+element+"&viewcode="+viewcode;
  try{
    const response = await fetch(url,{
      headers:{
      },
      method:"GET"
      }
    );
    if (!response.ok) {
      throw new Error(`Response status: ${response.status}`);
    }else{            
      const data = await response.text();
      return data;
    }
  }
  catch(error){
      if (error instanceof Error) {
          console.error(error.message);
        } else {
          console.error('An unknown error occurred');
        }
    return "error";
  }
}

export async function requestCreative(elements:string[]){ 

    console.log(elements);
    const payload: { elementList: string } = { elementList: ""};
    payload.elementList = JSON.stringify(elements);
    console.log(payload);
    const url = "/api/RequestCreative";
     try{
      const response = await fetch(url,{
         headers:{
          "Content-Type": "application/json"
         },
         method:"POST",
         body:JSON.stringify(payload)
        }
       );
       if (!response.ok) {
         throw new Error(`Response status: ${response.status}`);
       }else{            
         const data = await response.json();
         return data;
       }
     }
     catch(error){
         if (error instanceof Error) {
             console.error(error.message);
           } else {
             console.error('An unknown error occurred');
           }
      return [];
     }
  }

export async function doCreativeChange(change:CreativeChange){
  console.log(change);
  const url = "/api/DoCreativeChange";
     try{
      const response = await fetch(url,{
         headers:{
          "Content-Type": "application/json"
         },
         method:"POST",
         body:JSON.stringify(change)
        }
       );
       if (!response.ok) {
         throw new Error(`Response status: ${response.status}`);
       }else{            
         const data = await response.text();
         console.log(data);
         return data;
       }
     }
     catch(error){
         if (error instanceof Error) {
             console.error(error.message);
           } else {
             console.error('An unknown error occurred');
           }
      return [];
     }
}

export async function forgotPassword(user:string, email:string){
  const url = "/api/ForgotPassword?username="+user+"&email="+email;
  try{    
    const response = await fetch(url,{
      headers:{
      },
      method:"GET"
      }
    );
    if (!response.ok) {
      throw new Error(`Response status: ${response.status}`);
    }else{            
      const data = await response.text();
      return data;
    }
  }
  catch(error){
      if (error instanceof Error) {
          console.error(error.message);
        } else {
          console.error('An unknown error occurred');
        }
    return "error";
      }
}

export async function validateAPIKey(user:string, key:string){
  const url = "/api/ValidateAPIKey?u="+user+"&k="+key;
  try{    
    const response = await fetch(url,{
      headers:{
      },
      method:"GET"
      }
    );
    if (!response.ok) {
      throw new Error(`Response status: ${response.status}`);
    }else{            
      const data = await response.text();
      return data;
    }
  }
  catch(error){
      if (error instanceof Error) {
          console.error(error.message);
        } else {
          console.error('An unknown error occurred');
        }
    return "error";
      }
}

export async function checkAdGroup(element:string=""){
  const url = "/api/CheckAdGroup?element=" + element;
  try{
    const response = await fetch(url,{
      headers:{
      },
      method:"GET"
     }
    );
    console.log(response);
    
    if (!response.ok) {
      throw new Error(`Response status: ${response.status}`);
    }else{            
      const data = await response.json();
      return data;
    }
  }
  catch(error){
      if (error instanceof Error) {
          console.error(error.message);
        } else {
          console.error('An unknown error occurred');
        }
    return "error";
  }
}

export async function findSaleRep(rep:string=""){
  const url = "/api/FindSalesRep?rep=" + rep;
  try{
    const response = await fetch(url,{
      headers:{
      },
      method:"GET"
     }
    );
    console.log(response);
    
    if (!response.ok) {
      throw new Error(`Response status: ${response.status}`);
    }else{            
      const data = await response.json();
      return data;
    }
  }
  catch(error){
      if (error instanceof Error) {
          console.error(error.message);
        } else {
          console.error('An unknown error occurred');
        }
    return "error";
  }
}

export async function updateDashCols(dashCols:string){ 
  const url = "/api/UpdateUserDashCols";
    try{
    const response = await fetch(url,{
        headers:{
        "Content-Type": "application/json"
        },
        method:"POST",
        body:dashCols
      }
      );
      if (!response.ok) {
        throw new Error(`Response status: ${response.status}`);
      }else{            
        const data = await response.json();
        return data;
      }
    }
    catch(error){
        if (error instanceof Error) {
            console.error(error.message);
          } else {
            console.error('An unknown error occurred');
          }
    return [];
    }
}

export async function getCreatopyURL(element:string=""){
  const url = "/api/GetCreatopyURL?element=" + element + "&callBackURL=" + window.location.origin;
  try{
    const response = await fetch(url,{
      headers:{
      },
      method:"GET"
      }
    );
    console.log(response);
    
    if (!response.ok) {
      throw new Error(`Response status: ${response.status}`);
    }else{            
      await response.text().then(url=>{
        console.log(url);
        window.location.replace(url)
        //return url;
      });
    }
  }
  catch(error){
      if (error instanceof Error) {
          console.error(error.message);
        } else {
          console.error('An unknown error occurred');
        }
    return "error";
  }
}

export async function makeCreatopyProof(element:string=""){
  const url = "/api/MakeCreatopyProof?element=" + element;
  console.log(url);
  try{
    const response = await fetch(url,{
      headers:{
      },
      method:"GET"
    });
    console.log(response);
  
    if (!response.ok) {
      throw new Error(`Response status: ${response.status}`);
    }else{            
      await response.text().then(data=>{
        console.log(data);
        return data;
      });
    }
  }
  catch(error){
    if (error instanceof Error) {
        console.error(error.message);
      } else {
        console.error('An unknown error occurred');
      }
    return "error";
  }
}